module.exports = __webpack_public_path__ + "static/media/ic-nav-analysis-active.95d6c723.svg";